import React from 'react';
import { Svg } from "./Svg";

function isNumber(value) {
    return !isNaN(value) && !isNaN(parseFloat(value));
}

/**
 *
 * @param {string} url
 * @param {string} text
 * @param {string} iconName
 * @param {string|number} number
 * @param {function} onClick
 * @param hideNumber
 * @returns {JSX.Element}
 * @constructor
 */
const HeaderIconButton = ({url, text, iconName, onClick, number, hideNumber}) => {
    let showNumber = isNumber(number) && !hideNumber;

    return (
        <>
            <div className="header__icon-button">
                <a href={url} className="header__icon-button_link" rel="nofollow" title={text} onClick={onClick}>
                    <i className="header__icon-button_icon">
                        <Svg icon={iconName} />

                        {showNumber && <i className="header__icon-button_number">{number}</i>}
                    </i>

                    <span className="header__icon-button_title hide-on-large">{text}</span>
                </a>
            </div>
        </>
    );
};

export default HeaderIconButton;
